// extracted by mini-css-extract-plugin
export default {"exrate-wrap":"CurrencyExrate_exrate-wrap__coCUw"};